import { m } from 'framer-motion';
// @mui
import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import Badge from '@mui/material/Badge';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
// _mock
// components
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { varHover } from 'src/components/animate';
//
import * as React from "react";
import NotificationItem from './notification-item';
import {useAuthContext} from "../../../auth/hooks";
import {Notification} from "../../../types/user";

// ----------------------------------------------------------------------

const TABS = [
  {
    value: 'all',
    label: 'All',
    count: 22,
  },
  {
    value: 'unread',
    label: 'Unread',
    count: 12,
  },
  {
    value: 'archived',
    label: 'Archived',
    count: 10,
  },
];

// ----------------------------------------------------------------------

export default function NotificationsPopover() {
  const { user, notificationsData } = useAuthContext();
  const drawer = useBoolean();

  const smUp = useResponsive('up', 'sm');

  // const [currentTab, setCurrentTab] = useState('all');
  //
  // const handleChangeTab = useCallback((event: React.SyntheticEvent, newValue: string) => {
  //   setCurrentTab(newValue);
  // }, []);

  // const totalUnRead = notifications.filter((item) => item.isUnRead === true).length;

  // const handleMarkAllAsRead = () => {
  //   setNotifications(
  //     notifications.map((notification) => ({
  //       ...notification,
  //       isUnRead: false,
  //     }))
  //   );
  // };

  if(!user || !notificationsData) {
    return null;
  }

  const notifications = notificationsData.list as Notification[] || [];

  // if(new MobileDetect(window.navigator.userAgent).os() === 'AndroidOS' && !process.env.REACT_APP_MOBILE) {
  //   notifications = [{
  //     id: 121212,
  //     type: 'androidApp',
  //     createdAt: new Date(2023, 11, 30, 14, 30),
  //     userId: '1',
  //     metadata: {},
  //   }, ...notifications];
  // }

  const renderHead = (
    <Stack direction="row" alignItems="center" sx={{ py: 2, pl: 2.5, pr: 1, minHeight: 68 }}>
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        Нотификации
      </Typography>

      {/* {!!totalUnRead && ( */}
      {/*  <Tooltip title="Mark all as read"> */}
      {/*    <IconButton color="primary" onClick={handleMarkAllAsRead}> */}
      {/*      <Iconify icon="eva:done-all-fill" /> */}
      {/*    </IconButton> */}
      {/*  </Tooltip> */}
      {/* )} */}

      {!smUp && (
        <IconButton onClick={drawer.onFalse}>
          <Iconify icon="mingcute:close-line" />
        </IconButton>
      )}
    </Stack>
  );

  // const renderTabs = (
  //   <Tabs value={currentTab} onChange={handleChangeTab}>
  //     {TABS.map((tab) => (
  //       <Tab
  //         key={tab.value}
  //         iconPosition="end"
  //         value={tab.value}
  //         label={tab.label}
  //         icon={
  //           <Label
  //             variant={((tab.value === 'all' || tab.value === currentTab) && 'filled') || 'soft'}
  //             color={
  //               (tab.value === 'unread' && 'info') ||
  //               (tab.value === 'archived' && 'success') ||
  //               'default'
  //             }
  //           >
  //             {tab.count}
  //           </Label>
  //         }
  //         sx={{
  //           '&:not(:last-of-type)': {
  //             mr: 3,
  //           },
  //         }}
  //       />
  //     ))}
  //   </Tabs>
  // );

  const renderList = (
    <Scrollbar>
      <List disablePadding>
        {notifications.map((notification: Notification) => (
          <NotificationItem key={notification.id} notification={notification} />
        ))}
      </List>
    </Scrollbar>
  );

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        color={drawer.value ? 'primary' : 'default'}
        onClick={drawer.onTrue}
      >
        <Badge badgeContent={notifications.length} color="error">
          <Iconify icon="solar:bell-bing-bold-duotone" width={24} />
        </Badge>
      </IconButton>

      <Drawer
        open={drawer.value}
        onClose={drawer.onFalse}
        anchor="right"
        slotProps={{
          backdrop: { invisible: true },
        }}
        PaperProps={{
          sx: { width: 1, maxWidth: 420 },
        }}
      >
        {renderHead}

        <Divider />

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ pl: 2.5, pr: 1 }}
        >
          {/* {renderTabs} */}
          {/* <IconButton onClick={handleMarkAllAsRead}> */}
          {/*  <Iconify icon="solar:settings-bold-duotone" /> */}
          {/* </IconButton> */}
        </Stack>

        <Divider />

        {renderList}

        {/* <Box sx={{ p: 1 }}> */}
        {/*  <Button fullWidth size="large"> */}
        {/*    View All */}
        {/*  </Button> */}
        {/* </Box> */}
      </Drawer>
    </>
  );
}
